// extracted by mini-css-extract-plugin
export default {"poster":"edition_poster__gOCIR","frame":"edition_frame__1dY3_","link":"edition_link__1ffN7","zoomButton":"edition_zoomButton__Prtji","year":"edition_year__tbz14"};